import React from "react";
import { Outlet } from "react-router-dom";
import Grid from "@mui/material/Grid";

const Library = (props) => {
  return (
    <Grid container>
      <Outlet></Outlet>
    </Grid>
  );
};

export default Library;